/*=========================================================================================
  File Name: getters.js
  Description: Vuex Store - getters
  ----------------------------------------------------------------------------------------
  Item Name: ITAT Time
==========================================================================================*/

import { isConcatSpreadable } from 'core-js/fn/symbol'

// added so later we can keep breakpoint in sync automatically using this config file
// import tailwindConfig from "../../tailwind.config.js"
const moment = require('moment') // require

const getters = {

  // COMPONENT
  // vx-autosuggest
  // starredPages: state => state.navbarSearchAndPinList.data.filter((page) => page.highlightAction),
  windowBreakPoint: state => {

    // This should be same as tailwind. So, it stays in sync with tailwind utility classes
    if (state.windowWidth >= 1200) return 'xl'
    else if (state.windowWidth >= 992) return 'lg'
    else if (state.windowWidth >= 768) return 'md'
    else if (state.windowWidth >= 576) return 'sm'
    else return 'xs'
  },

  scrollbarTag: state => {
    return state.is_touch_device ? 'div' : 'VuePerfectScrollbar'
  },
  GetTimeEntryList : state => {
    return state.timeEntryList
  },
  GetCategoryList : state => {
    return state.categoryList
  },
  GetCategoryListSOW : state => {
    return state.categoryListSOW
  },
  GetCategoryListCombined : state => {
    return state.categoryListSOW.concat(state.categoryList)
  },
  GetClientListAll : state => {
    return state.clientList || []
  },
  GetClientList : state => {
    return (state.clientList || []).filter(x => x != null && x.Inactive == false)
  },
  GetClientNameList : state => {
    return (state.clientList || []).map(c => c.ClientName)
  },
  GetClientCategoryNameList : state => {
    const clientCategoryList = state.clientCategoryList
    const clientCategoryNameList = []
    for (let i = 0; i < clientCategoryList.length; i++) {
      clientCategoryNameList.push(clientCategoryList[i].CategoryName)
    }
    return clientCategoryNameList
  },
  GetClientCategoryList : state => {
    return state.clientCategoryList
  },
  GetWorkerList : state => {
    return (state.workerList || []).filter(x => x != null && x.WorkerType != 3)
  },
  GetFullWorkerList : state => {
    return state.workerList || []
  },
  GetSyncedWorkerList : state => {
    return (state.workerList || []).filter(x => x != null && x.WorkerType != 3)
  },
  GetSettingsModal : state => {
    return state.modals['SettingsModal']
  },
  GetAlertModal : state => {
    return state.modals['AlertModal']
  },
  GetUserLoggedIn : state => {
    return state.userLoggedIn
  },
  GetReceivedGlobalData : state => {
    return state.receivedGlobalData
  },
  GetTimeEntryPrompt : state => {
    return state.timeEntryPrompt
  },
  GetTimeEntryPromptActive : state => {
    return state.timeEntryPrompt.active
  },
  GetTimeEntryPromptTick : state => {
    return state.timeEntryPromptTick
  },
  GetCurrentTimeEntry : state => {
    return state.currentTimeEntry
  },
  GetSubTimeEntry : state => {
    return state.subTimeEntry
  },
  GetIsAdmin : state => {
    return state.isAdmin
  },
  GetActiveRequests : state => {
    return state.activeRequests
  },
  GetIsLoading : state => {
    return state.activeRequests > 0
  },
  GetDevOpsPAT: state => {
    return state.devOpsPAT
  },
  GetWorkerID : state => {
    return state.workerID
  },
  GetAuthWorkerID : state => {
    return state.authWorkerID
  },
  GetIsClient : state => {
    return state.isClient
  },
  GetIsWorker : state => {
    return state.isWorker
  },
  GetProjectList : state => {
    return state.projectList
  },
  GetProjectStatuses : state => {
    return state.projectStatuses
  },
  GetTaskStatusLookups (state, payload) {
    return state.taskStatusLookups
  },
  GetSOWStatusLookups : state => {
    return state.sowStatusLookups
  },
  GetSOWOverageStatusLookups : state => {
    return state.sowOverageStatusLookups
  },
  GetTaskList : state => {
    return state.taskList
  },
  GetTaskListAll : state => {
    return state.taskListAll
  },
  GetTaskListUncompleted: state => {
    return state.taskListUncompleted
  },
  GetMyTaskListV2: state => {
    return state.myTaskList
  },
  GetAllTaskList: state => state.allTaskList,
  GetTaskListByClient: (state) => (clientID) => {
    return state.taskList.filter(x => x.ITATInfo.ClientID === clientID)
  },
  GetTaskListByProject : state => (projectID) => {
    return state.taskList.filter(x => x.ITATInfo.ProjectID === projectID)
  },
  // Guaruntees tasks are assigned to this worker in Jira
  GetTaskListByJiraWorker : state => (workerID) => {
    return state.taskList.filter(x => {
      let accountID = ""
      if(x.JiraInfo.fields.assignee != null){
        accountID = x.JiraInfo.fields.assignee.accountId
      }
      return workerID == accountID
    })
  },
  GetPotentialExternalTask : state => {
    return state.potentialExternalTask
  },
  GetMyTaskList : (state, getters) => {
    return state.taskList.filter(x => x.ITATWorkerID == getters.GetWorkerID)
  },
  GetMonthlyTable : state => {
    return state.monthlyTable
  },
  GetQuarterlyData : state => {
    return state.quarterlyData
  },
  GetSelectedProject : state => {
    const projs = state.projectList.filter(x => x.ITATInfo.ProjectID == state.selectedProjectID)
    if (projs.length > 0 && projs != null) {
      return projs[0]
    } else {
      return null
    }
  },
  GetSOWSelectedTasks : state => {
    return state.sowSelectedTasks
  },
  GetSelectedProjectID : state => {
    return state.selectedProjectID
  },
  GetRawTotalHoursWorked : state => {
    return state.rawTotalHoursWorked
  },
  GetBillableWeeklyWorked : state => {
    return state.billableWeeklyWorked
  },
  GetRawTotalHoursWorkedWeekly : state => {
    return state.rawTotalHoursWorkedWeekly
  },
  GetWeeklyMileage: state => {
    return state.weeklyMileage
  },
  GetStatsHours : state => {
    return state.statsHours
  },
  GetWorkerMessages : state => {
    return state.workerMessages
  },
  GetDBTimeFormatting : state => {
    return state.dbTimeFormatting
  },
  GetSimulation : state => {
    return state.simulation
  },
  GetIsSimulation : state => state.isSimulation,
  GetIsEveryone : state => {
    return state.isEveryone
  },
  GetJiraDomain : state => {
    return state.jiraDomain
  },
  GetSOWList : state => {
    return state.sowList
  },
  GetDevOpsReleaseDefs : state => {
    return state.devOpsReleaseDefs
  },
  GetMySOWLineItems: state => {
    return state.mySOWLineItems
  }

}

export default getters
